var path = window.location.pathname;

common();
if (!isStageEnv) {
	captcha();
}
customerCare();
login();
navbar();
cssAnimationControll();
tasilPlus();
optOut();
resetPassword();
completeRegistration();
registrationConfirm();

var isLogged = false;

$.ajax({
	url: apiPath + "api/users/auth",
	type: "GET",
	success: function (data) {
		if (data.isLogged) {
			isLogged = true;
			redirectLoggedUserToApp();
		}
		actionBotConfig();
	},
	error: function () {
		actionBotConfig();
	}
});

$(document).ready(function () {
	activeCampaignSetUp();
});

function redirectLoggedUserToApp() {
	if (
		path == "/" ||
		path.indexOf("loginpage") > -1 ||
		path.indexOf("userregistration") > -1
	) {
		window.location.replace(apiPath + "app");
	}
}

function actionBotConfig() {
	window.__actionBot = {};
	window.__actionBot.config = {
		PUBLIC: {
			welcomeMessage: { context: { login: isLogged }, text: "" }
		}
	};
	actionBot();
}

function activeCampaignSetUp() {
	(function (e, t, o, n, p, r, i) {
		e.visitorGlobalObjectAlias = n;
		e[e.visitorGlobalObjectAlias] =
			e[e.visitorGlobalObjectAlias] ||
			function () {
				(e[e.visitorGlobalObjectAlias].q =
					e[e.visitorGlobalObjectAlias].q || []).push(arguments);
			};
		e[e.visitorGlobalObjectAlias].l = new Date().getTime();
		r = t.createElement("script");
		r.src = o;
		r.async = true;
		i = t.getElementsByTagName("script")[0];
		i.parentNode.insertBefore(r, i);
	})(
		window,
		document,
		"https://diffuser-cdn.app-us1.com/diffuser/diffuser.js",
		"vgo"
	);
	vgo("setAccount", "650294875");
	vgo("setTrackByDefault", true);

	vgo("process");
}
